import { render, staticRenderFns } from "./DateRange.vue?vue&type=template&id=2225a28c&scoped=true&"
import script from "./DateRange.vue?vue&type=script&lang=js&"
export * from "./DateRange.vue?vue&type=script&lang=js&"
import style0 from "./DateRange.vue?vue&type=style&index=0&id=2225a28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2225a28c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2225a28c')) {
      api.createRecord('2225a28c', component.options)
    } else {
      api.reload('2225a28c', component.options)
    }
    module.hot.accept("./DateRange.vue?vue&type=template&id=2225a28c&scoped=true&", function () {
      api.rerender('2225a28c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8YQZm2NC2f3Pu/JS/comp/DateRange.vue"
export default component.exports